<template>
  <div>
    <slot name="header">
      <LayoutHeader />
    </slot>
    <main class="flex flex-col min-h-md mt-[55px] lg:mt-0 flex-1">
      <slot />
    </main>
    <slot name="footer">
      <LazyFooterJav v-if="isAlt" />
      <LazyFooter v-else />
    </slot>
  </div>
</template>

<script lang="ts" setup>
const { isAlt } = useTheme()
</script>
